import { CheckCircle, X } from "lucide-react";

export default function Toast({ show, message, onClose }) {
  if (!show) return null;
  
  return (
    <div className="toast success">
      <CheckCircle size={20} />
      <span>{message}</span>
      <button onClick={onClose}>
        <X size={18} />
      </button>
    </div>
  );
}